export default __webpack_public_path__ + "static/media/chevron-left.bab1d8d7.svg";